console.log('>> Global loaded script.');
// import global dependencies
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { TabulatorFull as Tabulator } from 'tabulator-tables';
import { Fancybox } from '@fancyapps/ui';
import { initSeasonSwitcher, updateSeasonTitleFrom } from './season-switcher.js';

/* ------------------ fancyapps ------------------- */
Fancybox.bind("[data-fancybox]", {
  zoomEffect: false,
  Carousel: {
    Toolbar: {
      display: {
        left: ["counter"],
        middle: [],
        right: ["download","autoplay", "close","slideshow", "fullscreen", "thumbs", "zoom"],
      },
    },
  },
});

/* ------------------ Back To Top ------------------- */
function initBackToTop() {
  const scrollBtn = document.querySelector('#under-footer-back-to-top .btn');
  if (!scrollBtn) return;
  scrollBtn.addEventListener('click', () => {
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, 0); }
  });
  const TOGGLE_OFFSET = 200;
  const toggleVisibility = () => {
    if (window.scrollY > TOGGLE_OFFSET) scrollBtn.classList.add('visible');
    else scrollBtn.classList.remove('visible');
  };
  toggleVisibility();
  window.addEventListener('scroll', toggleVisibility, { passive: true });
  scrollBtn.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollBtn.click();
    }
  });
}
document.addEventListener('DOMContentLoaded', initBackToTop);

/* ------------------ bootstrap-select + tabulator résultats ----------------- */
(function initResultsTabulator(){
  const resultsTableEl = document.getElementById('data-results');
  if(!resultsTableEl) return; // ne pas perturber les autres pages (ex: select saison)
  // on ne veut PAS utiliser le select de saison (#seasonSelect)
  let selectPicker = document.querySelector('.form-select[data-results-select]');
  if(!selectPicker){
    // fallback: premier .form-select qui n'est pas seasonSelect
    const candidate = document.querySelector('.form-select');
    if(candidate && candidate.id !== 'seasonSelect') selectPicker = candidate;
  }
  if(!selectPicker) return;
  const url_string = window.location.href.toLowerCase();
  const url = new URL(url_string);
  const results = url.searchParams.get('results');

  function loadDataTable(icname){
    const table = new Tabulator('#data-results', {
      layout: 'fitColumns',
      pagination: 'local',
      paginationSize: 25,
      paginationSizeSelector: [10,25,50,true],
      paginationCounter: 'rows',
      locale: false,
      langs: { 'fr-fr': { pagination: { page_size: 'Afficher', first: 'Premier', first_title: 'Première Page', last: 'Dernier', last_title: 'Dernière Page', prev: 'Précédent', prev_title: 'Page Précédente', next: 'Suivant', next_title: 'Page Suivante', all: 'Toutes', counter: { showing: "Affichage de l'élément", of: 'sur', rows: 'éléments', pages: 'pages', }, }, }, },
      ajaxURL: require('../data/' + icname + '.json'),
      ajaxContentType: 'application/json; charset=utf-8',
      initialSort: [{ column: 'nom', dir: 'asc' }],
      columns: [
        { title: 'Nom', field: 'nom', headerFilter: 'input', headerFilterPlaceholder: 'Filtrer sur un nom' },
        { title: 'Prénom', field: 'prenom', headerFilter: 'input', headerFilterPlaceholder: 'Filtrer sur un prénom' },
        { title: 'Sexe', field: 'sexe', headerFilter: 'input', headerFilterPlaceholder: 'Filtrer sur le sexe' },
        { title: 'Classement', field: 'classement', headerFilter: 'input', headerFilterPlaceholder: 'Filtrer sur le rang' },
        { title: 'Année', field: 'annee', headerFilter: 'input', headerFilterPlaceholder: 'Filtrer sur la catégorie' },
      ],
      ajaxResponse: (url, params, response) => response.data,
    });
    table.on('dataLoaded', () => table.setLocale('fr-fr'));
  }

  selectPicker.addEventListener('change', (e)=>{
    const v = e.target.value;
    if(v) loadDataTable(v);
  });
  if(results){
    selectPicker.value = results;
    loadDataTable(results);
  }
})();

/* ------------------ Ouvrir collapse depuis hash (news/agenda) ----------------- */
document.addEventListener('DOMContentLoaded', function () {
  try {
    if (!location.hash) return;
    const rawHash = decodeURIComponent(location.hash);
    let target = null;
    try { target = document.querySelector(rawHash + '.collapse'); } catch (e) { target = null; }
    if (!target) { try { target = document.querySelector(rawHash); } catch (e) { target = null; } }
    if (!target) return;
    try {
      const headingId = target.getAttribute && target.getAttribute('aria-labelledby');
      const headerEl = headingId ? document.getElementById(headingId) : null;
      const headerToggle = headerEl ? headerEl.querySelector('[data-bs-toggle="collapse"]') : null;
      if (!headerToggle) return; // pas de toggle => on n'ouvre pas automatiquement
    } catch (e) {}
    const CollapseAPI = (typeof bootstrap !== 'undefined' && bootstrap.Collapse) ? bootstrap.Collapse : (window.bootstrap && window.bootstrap.Collapse) ? window.bootstrap.Collapse : null;
    if (CollapseAPI && typeof CollapseAPI.getOrCreateInstance === 'function') {
      try {
        const inst = CollapseAPI.getOrCreateInstance(target);
        if (inst && typeof inst.show === 'function') inst.show(); else if (inst && typeof inst.toggle === 'function') inst.toggle(); else target.classList.add('show');
      } catch (e) { target.classList.add('show'); }
    } else {
      target.classList.add('show');
    }
  } catch (e) { console.warn('collapse hash handler error', e); }
});

/* ------------------ Cloudinary gallery ----------------- */
(function initCloudinaryGallery(){
  let tag = document.querySelector('.tag');
  if (!tag || typeof tag.innerHTML === null) return;
  tag = tag.innerHTML;
  const cloudName = 'dxv2lgmfs';
  const tags = { tag: tag };
  // eslint-disable-next-line no-undef
  const myGallery = cloudinary.galleryWidget({
    container: '#portfolio-wrapper',
    cloudName: cloudName,
    mediaAssets: [tags],
    displayProps: { mode: 'expanded', columns: 4 },
    aspectRatio: '4:3',
    imageBreakpoint: 150,
    viewportBreakpoints: [
      { breakpoint: 600, carouselStyle: 'thumbnails', carouselLocation: 'bottom' },
      { breakpoint: 300, carouselStyle: 'indicators', carouselLocation: 'bottom', navigation: 'always' },
    ],
    borderWidth: 5,
    zoomProps: { type: 'popup', steps: 3, showTip: 'never' },
  });
  myGallery.render();
})();

/* ------------------ Interception header pour collapse ------------------- */
document.addEventListener('click', function (e) {
  try {
    const header = e.target.closest('.card-header');
    if (!header) return;
    const headerToggle = header.querySelector('[data-bs-toggle="collapse"]');
    if (!headerToggle) return;
    if (!e.target.closest('[data-bs-toggle="collapse"]')) {
      e.stopPropagation();
      e.preventDefault();
    }
  } catch (err) {}
});

document.addEventListener('keydown', function (e) {
  try {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    const focused = document.activeElement;
    if (!focused) return;
    const header = focused.closest && focused.closest('.card-header');
    if (!header) return;
    if (focused.closest && focused.closest('[data-bs-toggle="collapse"]')) return;
    e.preventDefault();
    e.stopPropagation();
  } catch (err) {}
});

(function () {
  try {
    document.addEventListener('shown.bs.collapse', function (ev) {
      try {
        const target = ev.target;
        if (!target || !target.id) return;
        const toggle = document.querySelector('[data-bs-target="#' + target.id + '"]');
        if (toggle) toggle.classList.add('rotated');
      } catch (e) {}
    });
    document.addEventListener('hidden.bs.collapse', function (ev) {
      try {
        const target = ev.target;
        if (!target || !target.id) return;
        const toggle = document.querySelector('[data-bs-target="#' + target.id + '"]');
        if (toggle) toggle.classList.remove('rotated');
      } catch (e) {}
    });
  } catch (e) {}
})();
